// import React from "react";
// import PropTypes from "prop-types";

// import TextField from "@mui/material/TextField";

// export function TextFieldForm({formik, field, label, ...props}) {
// 	return (
// 		<TextField
// 			required
// 			fullWidth
// 			id={label}
// 			label={label}
// 			InputLabelProps={{
// 				shrink: formik.values[field] !== undefined && formik.values[field] !== null && formik.values[field] !== "",
// 			}}
// 			name={field}
// 			value={formik.values[field]}
// 			onChange={formik.handleChange}
// 			onClick={(e) => {
// 				e.target.showPicker && e.target.showPicker();
// 			}}
// 			onBlur={formik.handleBlur}
// 			error={Boolean(formik.errors[field]) && formik.touched[field]}
// 			helperText={Boolean(formik.errors[field]) && formik.touched[field] ? formik.errors[field] : ""}
// 			sx={{
// 				"& .MuiInputLabel-asterisk": {
// 					color: "red",
// 					fontSize: 18,
// 				},
// 				"& .MuiInputBase-multiline": {
// 					p: 0,
// 					m: 0,
// 					maxHeight: 120,
// 					minHeight: 120,
// 				},
// 			}}
// 			{...props}
// 		/>
// 	);
// }

// TextFieldForm.propTypes = {
// 	formik: PropTypes.object,
// 	field: PropTypes.string,
// 	label: PropTypes.string,
// };

import React from "react";
import PropTypes from "prop-types";

import {TextField, FormControl, InputLabel, FormHelperText, Box, InputAdornment} from "@mui/material";

export function TextFieldForm({formik, field, label, topSubText, bottomSubText, required = true, startAdornment, ...props}) {
	const hasError = Boolean(formik.errors[field] && formik.touched[field]);

	return (
		<FormControl fullWidth error={hasError}>
			{/* Label */}
			<InputLabel shrink={formik.values[field] !== undefined && formik.values[field] !== null && formik.values[field] !== ""}>
				{label} {required && <span style={{color: ""}}>*</span>}
			</InputLabel>

			{/* Sub text BETWEEN label & input */}
			{topSubText && <Box sx={{fontSize: 12, color: "text.secondary", mb: 0.5}}>{topSubText}</Box>}

			{/* Input */}

			<TextField
				name={field}
				value={formik.values[field]}
				onChange={formik.handleChange}
				onBlur={formik.handleBlur}
				error={hasError}
				{...props}
			/>

			{/* Bottom helper / error text */}
			<FormHelperText>{hasError ? formik.errors[field] : bottomSubText}</FormHelperText>
		</FormControl>
	);
}

TextFieldForm.propTypes = {
	formik: PropTypes.object,
	field: PropTypes.string,
	label: PropTypes.string,
	topSubText: PropTypes.string,
	bottomSubText: PropTypes.string,
};
